module.exports = __webpack_public_path__ + "img/logo-orange-yellow-mobile.63915911.svg";